<template>
	<drawer
			title="Add comment"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				margin="5px 0"
				width="100%"
				label="Note"
				min-height="400px"
				placeholder="Enter text"
				:setInputValue="comment"
				@updateInput="onInput"
				is-textarea
		></field>
	</drawer>
</template>

<script>
import getDefaultDate from "@/helper/getDefaultDate";
import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	name: "CommentsDrawer",
	components: { Drawer },
	props: {
		editData: Object,
		created_by: Number,
		name: String
	},
	data: () => ({
		drawer: true,
		comment: ''
	}),
	methods: {
		onClose() {
			this.$emit('updateDrawer', false);
		},
		onInput({ value }) {
			this.comment = value;
		},
		onSave() {
			const values = {
				date: getDefaultDate(1),
				comment: this.comment,
				created_by: this.created_by,
				created_name: this.name
			};

			this.$emit('updateSave', values);
		}
	},
	mounted() {
		if (this.editData) this.comment = this.editData?.comment;
	}
};
</script>

